import { ApiErrorResponseWithCode } from '@vfde-sails/utils';
import { ErrorMessage } from '../enum';
import { JarvisProduct } from '@vfde-sails/avc-core';
import { HomesPassedType } from '../../../enums/product';

export const isApiError = (error: unknown): error is ApiErrorResponseWithCode =>
    null !== error
        && 'object' === typeof error
        && 'constructor' in error
        && error.constructor.name === ApiErrorResponseWithCode.name;

export const isNonUniqueAddressError = (error: unknown): error is Error =>
    null !== error
            && error instanceof Error
            && error.message === ErrorMessage.NON_UNIQUE_ADDRESS;

export const isAddressNotFoundError = (error: unknown): error is Error =>
    null !== error
            && error instanceof Error
            && error.message === ErrorMessage.ADDRESS_NOT_FOUND;

export const isEmptyResponeError = (error: unknown): error is Error =>
    null !== error
            && error instanceof Error
            && error.message === ErrorMessage.EMPTY_RESPONSE;

export const isAddressError = (error: unknown): error is Error =>
    isNonUniqueAddressError(error) || isAddressNotFoundError(error);

export const isAvcError = (error: unknown): error is Error=>
    isApiError(error) ||
    isAddressError(error) ||
    isEmptyResponeError(error);

export const isJarvisProduct = (product: unknown): product is JarvisProduct =>
    product !== null &&
    typeof product === 'object' &&
    'id' in product &&
    'download' in product &&
    'upload' in product &&
    'link' in product &&
    'name' in product &&
    'discount' in product &&
    'price' in product &&
    'productType' in product;

export const isJarvisProductArray = (products: unknown): products is JarvisProduct[] =>
    Array.isArray(products) &&
    products.length > 0 &&
    isJarvisProduct(products[0]);

export const isHomesPassedMarker = (marker: unknown): marker is HomesPassedType =>
    Object.values(HomesPassedType).includes(marker as HomesPassedType);
